export default class VodProviderService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/vodProviders', params)
	}
	getSimpleList(params) {
		return this.apiService.callGet('me/vodProviders/simple', params)
	}

	getListWithPackagesVisibility(params) {
		return this.apiService.callGet('me/vodProviders/listWithPackages', params)
	}


	getPackagesForService(params) {
		return this.apiService.callGet('me/vodProviders/packagesForService', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/vodProviders/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/VodProviderService.js